import React, { useEffect,  useRef, useState } from "react";

import { Row, Col, Offcanvas, Button } from "react-bootstrap";
import { FiMenu } from "react-icons/fi";
import { useLocation, useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { useDispatch, useSelector } from "react-redux";
import userImg from "../../../../img/DynamicSoftware.png";
import { MdOutlineSystemUpdateAlt } from "react-icons/md";
import { format } from "date-fns";
import {
  IoPersonOutline,
  IoCallOutline,
  IoMailOutline,
  IoLocationOutline,
  IoBusinessOutline,
} from "react-icons/io5";
import Sale from "./Compontes/Sale";
import Receipt from "./Compontes/Receipt";
import MonthlyItemQty from "./Compontes/MonthlyItemQTY";
import MonthlyItemAMT from "./Compontes/MonthlyItemAMT";
import MonthlyItemRate from "./Compontes/MonthlyItemRate";
import OutStandig from "./Compontes/OutStanding";
import Ledger from "./Compontes/Ledger";
import MonthlyLedger from "./Compontes/MonthLedger";
import FASFilterBox from "../../../../components/FilterBox/FASFilter/FASFilter";
import {
  CouSupAcGroupList,
  CustomerSupplierProAcDetail,
} from "../../../../Redux/Slice/Fas/Profile Analysis/Customer/CustomerSlice";
import { AcList } from "../../../../Redux/Slice/Fas/Financial Statement/Ledger/LedgerSlice";


import { Loader } from "../../../../components/Loader/Loader";
import { useTheme } from "../../../../Themecontext/Themecontext";
import Calendar from "react-calendar";
import FASCalender from "../../../../components/Calendar/FASCalender";

export const Customer = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("SALE");

  const { Colourdata, DataMain } = useSelector((state) => state.ClientLogin);
  const { CouSupAcGroupListdata, CustomerSupplierAcDetaildata } = useSelector(
    (state) => state.CustomerSlice,
  );

  const { AcListdata } = useSelector((state) => state.LedgerSlice);

  const iscolour = Colourdata?.data?.find((el) => el.ExeName === "NEWFAS");
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "NEWFASDARK",
  );

  const { theme } = useTheme();
  const isdark = theme;
  const Firm = Cookies.get("Firm");
  const YearId = Cookies.get("FinancialYear");
  const FinancialYear = Cookies.get("FinancialYear");

  // ✅ FILTER STATES
  const [search, setSearch] = useState({
    accountGroup: "",
    accountName: "",
  });
  const [filters, setFilters] = useState({
    accountGroup: [],
    accountName: [],
  });
  const [showDatePicker, setShowDatePicker] = useState(false);
  const showDateFilter =
    activeTab === "MONTHLY LEDGER" ||
    activeTab === "MONTHLY ITEM QTY" ||
    activeTab === "MONTHLY ITEM AMT" ||
    activeTab === "MONTHLY ITEM RATE" ||
    activeTab === "OUTSTANDING" ||
    activeTab === "LEDGER";

  const accountGroupList =
    CouSupAcGroupListdata?.CouAcGrp?.map((item) => ({
      label: item?.GroupMstName,
      value: item?.GroupMstID,
    })) || [];

  const accountNameList =
    AcListdata?.CouAcList?.map((item) => ({
      label: item?.AcName,
      value: item?.AcID,
    })) || [];

  // Voice Search Handle Effect
  useEffect(() => {
    if (location.state?.searchParty && accountNameList && accountNameList.length > 0) {
      const searchName = location.state.searchParty.toLowerCase();
      
      const stringSimilarity = (str1, str2) => {
        const getBigrams = (str) => {
          let bigrams = new Set();
          for (let i = 0; i < str.length - 1; i++) {
            bigrams.add(str.substring(i, i + 2));
          }
          return bigrams;
        };
        const bg1 = getBigrams(str1);
        const bg2 = getBigrams(str2);
        const union = bg1.size + bg2.size;
        if (union === 0) return 1;
        let hits = 0;
        for (let bg of bg1) {
          if (bg2.has(bg)) hits++;
        }
        return (2.0 * hits) / union;
      };

      const cleanString = (str) => {
        return str.replace(/\b(private|limited|pvt|ltd|and|co|company|opening)\b/gi, '').replace(/\s+/g, ' ').trim();
      };
      
      const cleanedSearch = cleanString(searchName);
      
      let bestMatch = null;
      let highestScore = 0;
      
      accountNameList.forEach(a => {
        const accLabel = a.label.toLowerCase();
        const cleanedLabel = cleanString(accLabel);
        
        let score = 0;
        if (accLabel === searchName) {
          score = 10;
        } else if (accLabel.includes(searchName)) {
          score = 5;
        } else {
          score = stringSimilarity(cleanedSearch, cleanedLabel);
          const searchWords = cleanedSearch.split(' ');
          const labelWords = cleanedLabel.split(' ');
          if (searchWords[0] && labelWords[0] && searchWords[0].length > 2) {
            if (labelWords[0].includes(searchWords[0]) || searchWords[0].includes(labelWords[0])) {
               score += 0.5;
            }
          }
        }
        
        if (score > highestScore) {
          highestScore = score;
          bestMatch = a;
        }
      });
      
      const matchedParty = highestScore > 0.3 ? bestMatch : null;

      if (matchedParty) {
        setFilters((prev) => {
          if (!prev.accountName.includes(matchedParty.value)) {
            return {
              ...prev,
              accountName: [matchedParty.value],
            };
          }
          return prev;
        });
        
        // Clear state to prevent infinite loops
        navigate(location.pathname, { replace: true, state: {} });
      }
    }
  }, [location.state, accountNameList, navigate, location.pathname]);

  const [dateRange, setDateRange] = useState([
    {
      startDate: null,
      endDate: null,
      key: "selection",
    },
  ]);

  function parseRangeToDates(rangeString) {
    if (!rangeString) return { startDate: null, endDate: null };

    const [startStr, endStr] = rangeString.split(" - ");

    const parseDDMMYYYY = (s) => {
      const [day, month, year] = s.split("/").map(Number);
      return new Date(year, month - 1, day);
    };

    return {
      startDate: parseDDMMYYYY(startStr),
      endDate: parseDDMMYYYY(endStr),
    };
  }

  const isFYDateSet = useRef(false);

  useEffect(() => {
    if (!DataMain || !FinancialYear) return;
    if (isFYDateSet.current) return;

    let matchedYear = null;

    DataMain?.AC_Year_List?.forEach((el) => {
      if (el.AcYearID === Number(FinancialYear)) {
        matchedYear = el.AcYear;
      }
    });

    if (matchedYear) {
      const { startDate, endDate } = parseRangeToDates(matchedYear);

      setDateRange([
        {
          startDate,
          endDate,
          key: "selection",
        },
      ]);

      isFYDateSet.current = true;
    }
  }, [DataMain, FinancialYear]);

  useEffect(() => {
    if (filters?.accountName?.length) {
      dispatch(
        CustomerSupplierProAcDetail({
          Firm,
          Year: YearId,
          AcIDs: filters.accountName[0].toString(),
        }),
      );
    }
  }, [filters?.accountName]);

  const selectedData =
    CustomerSupplierAcDetaildata?.AcData?.find(
      (item) => item?.AcID === filters.accountName[0],
    ) || CustomerSupplierAcDetaildata?.AcData?.[0];

  const [showFilter, setShowFilter] = useState(false);
  const handleClose = () => setShowFilter(false);
  const handleShow = () => setShowFilter(true);
  const [hoverIndex, setHoverIndex] = useState(null);

  useEffect(() => {
    dispatch(CouSupAcGroupList({ Firm, year: YearId }));
    dispatch(
      AcList({
        Firm,
        Year: YearId,
        AcIDs: filters.accountName[0],
      }),
    );
  }, [dispatch, Firm, YearId]);

  const selectAll = (type, items) => {
    const allIds = items.map((i) => i.value);

    setFilters((prev) => ({
      ...prev,
      [type]: prev[type].length === items.length ? [] : allIds,
    }));
  };

  const handleSearch = (type, value) => {
    setSearch((prev) => ({
      ...prev,
      [type]: value,
    }));
  };

  const toggleItem = (type, item) => {
    setFilters((prev) => {
      let newSelected = [];

      if (type === "accountGroup") {
        if (prev[type].includes(item.value)) {
          newSelected = prev[type].filter((id) => id !== item.value);
        } else {
          newSelected = [...prev[type], item.value];
        }

        dispatch(
          AcList({
            Firm,
            Year: YearId,
            selectedIds: newSelected.join(","),
          }),
        );
      }

      if (type === "accountName") {
        if (prev[type].includes(item.value)) {
          newSelected = [];
        } else {
          newSelected = [item.value];
        }
      }

      return {
        ...prev,
        [type]: newSelected,
      };
    });
  };

  const tabs = [
    "SALE",
    "RECEIPT",
    "MONTHLY LEDGER",
    "MONTHLY ITEM QTY",
    "MONTHLY ITEM AMT",
    "MONTHLY ITEM RATE",
    "OUTSTANDING",
    "LEDGER",
  ];
  const startDate = dateRange?.[0]?.startDate;
  const endDate = dateRange?.[0]?.endDate;

  const safeFormat = (date) => {
    if (!date || isNaN(new Date(date))) return null;
    return format(new Date(date), "yyyy-MM-dd");
  };

  const renderPage = () => {
    const commonProps = {
      accountGroup: filters.accountGroup,
      accountName: filters.accountName,
      startDate: safeFormat(startDate),
      endDate: safeFormat(endDate),
    };

    switch (activeTab) {
      case "SALE":
        return <Sale {...commonProps} />;

      case "RECEIPT":
        return <Receipt {...commonProps} />;

      case "MONTHLY LEDGER":
        return <MonthlyLedger {...commonProps} />;

      case "MONTHLY ITEM QTY":
        return <MonthlyItemQty {...commonProps} />;

      case "MONTHLY ITEM AMT":
        return <MonthlyItemAMT {...commonProps} />;

      case "MONTHLY ITEM RATE":
        return <MonthlyItemRate {...commonProps} />;

      case "OUTSTANDING":
        return <OutStandig {...commonProps} />;

      case "LEDGER":
        return <Ledger {...commonProps} />;

      default:
        return <Sale {...commonProps} />;
    }
  };
  const isAccountSelected = filters.accountName.length > 0;
  const dummyData = {
    AcName: CustomerSupplierAcDetaildata?.AcData?.[0]?.AcName,
    GroupName: CustomerSupplierAcDetaildata?.AcData?.[0]?.Group,
    Department: CustomerSupplierAcDetaildata?.AcData?.[0]?.Department,
    ContactPerson1: CustomerSupplierAcDetaildata?.AcData?.[0]?.ContactPerson1,
    ContactPerson2: CustomerSupplierAcDetaildata?.AcData?.[0]?.ContactPerson2,
    EmailID: CustomerSupplierAcDetaildata?.AcData?.[0]?.EmailID,
    TelephoneNO: CustomerSupplierAcDetaildata?.AcData?.[0]?.TelePhoneNo,
    BankDetail: CustomerSupplierAcDetaildata?.AcData?.[0]?.BankName,
    AccountNo: CustomerSupplierAcDetaildata?.AcData?.[0]?.BankAcNo,
    GSTNO: CustomerSupplierAcDetaildata?.AcData?.[0]?.GSTINNo,
    PanNo: CustomerSupplierAcDetaildata?.AcData?.[0]?.PanNo,
    MobilNO: CustomerSupplierAcDetaildata?.AcData?.[0]?.MobileNo,
    MobilNO1: CustomerSupplierAcDetaildata?.AcData?.[0]?.MobileNo2,
    MSMENO: CustomerSupplierAcDetaildata?.AcData?.[0]?.MSMENo,
    EmergencyNO: CustomerSupplierAcDetaildata?.AcData?.[0]?.EmergencyNo,
    IFSC: CustomerSupplierAcDetaildata?.AcData?.[0]?.IfscCode,
    Address1: CustomerSupplierAcDetaildata?.AcData?.[0]?.Address1,
    Address2: CustomerSupplierAcDetaildata?.AcData?.[0]?.Address2,
    Address3: CustomerSupplierAcDetaildata?.AcData?.[0]?.Address3,
  };

  const boxData = [
    {
      label: "Account Group",
      value: dummyData.GroupName,
      icon: <IoBusinessOutline />,
    },
    {
      label: "Production Group",
      value: dummyData.Department,
      icon: <IoBusinessOutline />,
    },
    {
      label: "Contact 1",
      value: dummyData.ContactPerson1,
      icon: <IoPersonOutline />,
    },
    {
      label: "Contact 2",
      value: dummyData.ContactPerson2,
      icon: <IoPersonOutline />,
    },
    { label: "Email", value: dummyData.EmailID, icon: <IoMailOutline /> },
    { label: "Phone", value: dummyData.TelephoneNO, icon: <IoCallOutline /> },
    { label: "Bank", value: dummyData.BankDetail, icon: <IoBusinessOutline /> },
    {
      label: "Account No",
      value: dummyData.AccountNo,
      icon: <IoBusinessOutline />,
    },
    // { label: "GST No", value: dummyData.GSTNO, icon: <IoBusinessOutline /> },
    { label: "PAN", value: dummyData.PanNo, icon: <IoBusinessOutline /> },
    { label: "Mobile", value: dummyData.MobilNO, icon: <IoCallOutline /> },
    { label: "Mobile 2", value: dummyData.MobilNO1, icon: <IoCallOutline /> },
    { label: "MSME", value: dummyData.MSMENO, icon: <IoBusinessOutline /> },
    {
      label: "Emergency",
      value: dummyData.EmergencyNO,
      icon: <IoCallOutline />,
    },
    { label: "IFSC", value: dummyData.IFSC, icon: <IoBusinessOutline /> },
  ];

  if (CouSupAcGroupListdata === null) {
    return (
      <div className="flex justify-center items-center h-screen text-xl text-green-700">
        <Loader />
      </div>
    );
  }

  if (AcListdata === null) {
    return (
      <div className="flex justify-center items-center h-screen text-xl text-green-700">
        <Loader />
      </div>
    );
  }

  return (
    <div
      style={{
        padding: "16px",
        background: isdark === "light" ? "#f7efdd " : iscolourDark?.Colour2,
        minHeight: "100vh",
      }}
    >
      <style>{`
        .hover-scale-btn {
          transition: transform 0.2s ease-in-out;
          transform: scale(1);
        }
        .hover-scale-btn:hover {
          transform: scale(1.02);
        }
        
      `}</style>

      {/* ✅ MOBILE FILTER BUTTON */}
      <div className="d-lg-none d-flex justify-content-end mb-3">
        <Button
          onClick={handleShow}
          style={{
            backgroundColor:
              isdark === "light" ? iscolour?.Colour6 : iscolourDark?.Colour8,
            color:
              isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour3,
            border: "none",
            borderRadius: "10px",
            padding: "8px 12px",
            boxShadow: "0 4px 10px rgba(0,0,0,0.18)",
          }}
        >
          <FiMenu size={22} />
        </Button>
      </div>

      {/* ✅ OFFCANVAS */}
      <Offcanvas
        show={showFilter}
        onHide={handleClose}
        placement="start"
        style={{
          background: isdark === "light" ? "#f7efdd " : iscolourDark?.Colour2,
        }}
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title
            style={{ color: isdark === "light" ? "#000" : "#fff" }}
          >
            Filters
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div
            style={{ display: "flex", flexDirection: "column", gap: "24px" }}
          >
            {showDateFilter && (
              <div>
                <div
                  style={{
                    backgroundColor:
                      isdark === "light"
                        ? iscolour?.Colour5
                        : iscolourDark?.Colour10,
                    padding: "13px 20px",
                    borderRadius: "10px 10px 0px 0px",
                  }}
                >
                  <h3
                    style={{
                      fontWeight: "700",
                      fontSize: "18px",
                      margin: 0,
                      color:
                        isdark === "light"
                          ? iscolour?.Colour1
                          : iscolourDark?.Colour1,
                      alignItems: "center",
                      display: "flex",
                    }}
                  >
                    {" "}
                    Date Range
                  </h3>
                </div>
                <div
                  style={{
                    border: `2px solid ${isdark === "light" ? iscolour?.Colour4 : iscolourDark?.Colour10}`,
                    padding: "15px",
                    marginBottom: "15px",
                    background:
                      isdark === "light"
                        ? iscolour?.Colour1
                        : iscolourDark?.Colour1,
                    borderRadius: "0px 0px 10px 10px",
                  }}
                >
                  <div
                    onClick={() => setShowDatePicker(true)}
                    style={{
                      marginTop: "8px",
                      padding: "10px",
                      border: `2px solid ${isdark === "light" ? iscolour?.Colour4 : iscolourDark?.Colour10}`,
                      borderRadius: "8px",
                      cursor: "pointer",
                      color:
                        isdark === "light" ? "#000" : iscolourDark?.Colour11,
                      textAlign: "center",
                    }}
                  >
                    {dateRange?.[0]?.startDate && dateRange?.[0]?.endDate
                      ? `${format(dateRange[0].startDate, "dd-MM-yyyy")} - ${format(dateRange[0].endDate, "dd-MM-yyyy")}`
                      : "Select Date Range"}
                  </div>
                </div>
              </div>
            )}

            <FASFilterBox
              title="Account Name"
              items={accountNameList}
              search={search.accountName}
              setSearch={(val) => handleSearch("accountName", val)}
              selectedItems={filters.accountName}
              toggleItem={(item) => toggleItem("accountName", item)}
              selectAll={() => selectAll("accountName", accountNameList)}
            />
            <FASFilterBox
              title="Account Group Name"
              items={accountGroupList}
              search={search.accountGroup}
              setSearch={(val) => handleSearch("accountGroup", val)}
              selectedItems={filters.accountGroup}
              toggleItem={(item) => toggleItem("accountGroup", item)}
              selectAll={() => selectAll("accountGroup", accountGroupList)}
            />
          </div>
        </Offcanvas.Body>
      </Offcanvas>

      <Row className="g-4 align-items-start">
        {/* ✅ DESKTOP FILTER */}
        <Col xl={3} lg={4} md={12} className="d-none d-lg-block">
          <div style={{ position: "sticky", top: "16px" }}>
            <div
              style={{ display: "flex", flexDirection: "column", gap: "24px" }}
            >
              {showDateFilter && (
                <div>
                  <div
                    style={{
                      backgroundColor:
                        isdark === "light"
                          ? iscolour?.Colour5
                          : iscolourDark?.Colour10,
                      padding: "13px 20px",
                      borderRadius: "10px 10px 0px 0px",
                    }}
                  >
                    <h3
                      style={{
                        fontWeight: "700",
                        fontSize: "18px",
                        margin: 0,
                        color:
                          isdark === "light"
                            ? iscolour?.Colour1
                            : iscolourDark?.Colour1,
                        alignItems: "center",
                        display: "flex",
                      }}
                    >
                      {" "}
                      Date Range
                    </h3>
                  </div>
                  <div
                    style={{
                      border: `2px solid ${isdark === "light" ? iscolour?.Colour4 : iscolourDark?.Colour10}`,
                      padding: "15px",
                      background:
                        isdark === "light"
                          ? iscolour?.Colour1
                          : iscolourDark?.Colour1,
                      borderRadius: "0px 0px 10px 10px",
                    }}
                  >
                    <div
                      onClick={() => setShowDatePicker(true)}
                      style={{
                        marginTop: "8px",
                        padding: "10px",
                        border: `2px solid ${isdark === "light" ? iscolour?.Colour4 : iscolourDark?.Colour10}`,
                        borderRadius: "8px",
                        cursor: "pointer",
                        color:
                          isdark === "light" ? "#000" : iscolourDark?.Colour11,
                        textAlign: "center",
                      }}
                    >
                      {dateRange?.[0]?.startDate && dateRange?.[0]?.endDate
                        ? `${format(dateRange[0].startDate, "dd-MM-yyyy")} - ${format(dateRange[0].endDate, "dd-MM-yyyy")}`
                        : "Select Date Range"}
                    </div>
                  </div>
                </div>
              )}
              <FASFilterBox
                title="Account Name"
                items={accountNameList}
                search={search.accountName}
                setSearch={(val) => handleSearch("accountName", val)}
                selectedItems={filters.accountName}
                toggleItem={(item) => toggleItem("accountName", item)}
                selectAll={() => selectAll("accountName", accountNameList)}
              />
              <FASFilterBox
                title="Account Group Name"
                items={accountGroupList}
                search={search.accountGroup}
                setSearch={(val) => handleSearch("accountGroup", val)}
                selectedItems={filters.accountGroup}
                toggleItem={(item) => toggleItem("accountGroup", item)}
                selectAll={() => selectAll("accountGroup", accountGroupList)}
              />
            </div>
          </div>
        </Col>

        {/* ✅ RIGHT SIDE */}
        <Col xl={9} lg={8} md={12}>
          {/* ✅ RESPONSIVE TABS */}
          <Row className="g-2 mb-3">
            {tabs.map((tab, index) => {
              const isActive = activeTab === tab;

              return (
                <Col xl={3} lg={4} md={6} sm={6} xs={6} key={index}>
                  <button
                    onClick={() => setActiveTab(tab)}
                    className="hover-scale-btn"
                    style={{
                      width: "100%",
                      height: "58px",
                      backgroundColor: isActive
                        ? isdark === "light"
                          ? iscolour?.Colour5
                          : iscolourDark?.Colour10
                        : isdark === "light"
                          ? iscolour?.Colour1
                          : iscolourDark?.Colour3,
                      border: `2px solid ${isActive
                          ? isdark === "light"
                            ? iscolour?.Colour5
                            : iscolourDark?.Colour10
                          : isdark === "light"
                            ? iscolour?.Colour4
                            : iscolourDark?.Colour10
                        }`,
                      borderRadius: "14px",
                      fontWeight: "bold",
                      color: isActive
                        ? isdark === "light"
                          ? iscolour?.Colour1
                          : iscolourDark?.Colour1
                        : isdark === "light"
                          ? iscolour?.Colour11
                          : iscolourDark?.Colour9,
                      fontSize: "14px",
                    }}
                  >
                    {tab}
                  </button>
                </Col>
              );
            })}
          </Row>
          {isAccountSelected && (
            <div
              style={{
                marginTop: "15px",
                borderRadius: "12px",
                background:
                  isdark === "light"
                    ? iscolour?.Colour1
                    : iscolourDark?.Colour2,
              }}
            >
              <Row>
                <Col xl={12} lg={12} md={12}>
                  <div
                    style={{
                      border: `1px solid ${isdark === "light"
                          ? iscolour?.Colour5
                          : iscolourDark?.Colour10
                        }`,
                      borderRadius: "10px",
                      overflow: "hidden",
                      background:
                        isdark === "light"
                          ? iscolour?.Colour1
                          : iscolourDark?.Colour2,
                    }}
                  >
                    <div
                      style={{
                        padding: "20px",
                        background:
                          isdark === "light"
                            ? iscolour?.Colour3
                            : iscolourDark?.Colour3,
                        borderBottom: `1px solid ${isdark === "light"
                            ? iscolour?.Colour5
                            : iscolourDark?.Colour10
                          }`,
                      }}
                    >
                      <Row className="align-items-center">
                        <Col xs={12}>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "20px",
                              flexWrap: "wrap",
                            }}
                          >
                            {/* IMAGE */}
                            <img
                              src={userImg}
                              alt="Customer"
                              style={{
                                width: "95px",
                                height: "95px",
                                borderRadius: "20px",
                                border: `2px solid ${isdark === "light"
                                    ? iscolour?.Colour5
                                    : iscolourDark?.Colour10
                                  }`,
                              }}
                            />

                            {/* TEXT */}
                            <div style={{ flex: 1 }}>
                              <h5
                                style={{
                                  color:
                                    isdark === "light"
                                      ? iscolour?.Colour11
                                      : iscolourDark?.Colour9,
                                  marginBottom: "6px",
                                  fontWeight: "700",
                                }}
                              >
                                {dummyData.AcName}
                              </h5>

                              <div style={{ display: "flex", gap: "8px" }}>
                                <IoLocationOutline
                                  style={{
                                    color:
                                      isdark === "light"
                                        ? iscolour?.Colour11
                                        : iscolourDark?.Colour10,
                                    marginTop: "3px",
                                  }}
                                />

                                <span
                                  style={{
                                    fontSize: "13px",
                                    color:
                                      isdark === "light"
                                        ? iscolour?.Colour11
                                        : iscolourDark?.Colour9,
                                    wordBreak: "break-word",
                                    overflowWrap: "break-word",
                                    whiteSpace: "normal",
                                    display: "block",
                                    lineHeight: "18px",
                                  }}
                                >
                                  {dummyData.Address1 && (
                                    <div>{dummyData.Address1}</div>
                                  )}
                                  {dummyData.Address2 && (
                                    <div>{dummyData.Address2}</div>
                                  )}
                                  {dummyData.Address3 && (
                                    <div>{dummyData.Address3}</div>
                                  )}
                                </span>
                              </div>
                            </div>
                            <div
                              style={{
                                flexShrink: 0,
                                width: "200px",
                                padding: "10px 14px",
                                borderRadius: "12px",
                                display: "flex",
                                alignItems: "center",
                                gap: "10px",
                                whiteSpace: "nowrap",
                                background:
                                  isdark === "light"
                                    ? iscolour?.Colour5
                                    : iscolourDark?.Colour10,
                                border: `1px solid ${isdark === "light"
                                    ? iscolour?.Colour5
                                    : iscolourDark?.Colour10
                                  }`,
                                backdropFilter: "blur(14px)",
                              }}
                            >
                              <IoBusinessOutline />
                              <div>
                                <div style={{ fontSize: "11px", opacity: 0.8 }}>
                                  GST No
                                </div>
                                <div
                                  style={{
                                    fontWeight: "700",
                                    fontSize: "15px",
                                  }}
                                >
                                  {dummyData.GSTNO}
                                </div>
                              </div>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </div>

                    {/* 🔽 BOTTOM SECTION */}
                    <div style={{ padding: "12px" }}>
                      <Row className="g-2">
                        {boxData.map((item, i) => (
                          <Col xl={4} lg={4} md={6} sm={6} xs={12} key={i}>
                            <div
                              onMouseEnter={() => setHoverIndex(i)}
                              onMouseLeave={() => setHoverIndex(null)}
                              style={{
                                border: `1px solid ${isdark === "light"
                                    ? iscolour?.Colour5
                                    : iscolourDark?.Colour10
                                  }`,
                                borderRadius: "8px",
                                padding: "10px",
                                height: "70px",
                                display: "flex",
                                alignItems: "center",
                                gap: "10px",
                                background:
                                  hoverIndex === i
                                    ? isdark === "light"
                                      ? iscolour?.Colour2
                                      : iscolourDark?.Colour4
                                    : isdark === "light"
                                      ? iscolour?.Colour1
                                      : iscolourDark?.Colour2,
                              }}
                            >
                              <div
                                style={{
                                  fontSize: "18px",
                                  minWidth: "24px",
                                  display: "flex",
                                  justifyContent: "center",
                                  color:
                                    isdark === "light"
                                      ? iscolour?.Colour5
                                      : iscolourDark?.Colour10,
                                  background:
                                    isdark === "light"
                                      ? iscolour?.Colour3
                                      : iscolourDark?.Colour3,
                                  padding: "8px",
                                  borderRadius: "6px",
                                }}
                              >
                                {item.icon}
                              </div>

                              <div style={{ flex: 1, overflow: "hidden" }}>
                                <div
                                  style={{
                                    fontSize: "14px",
                                    color:
                                      isdark === "light"
                                        ? iscolour?.Colour6
                                        : iscolourDark?.Colour10,
                                  }}
                                >
                                  {item.label}
                                </div>
                                <div
                                  style={{
                                    fontSize: "13px",
                                    fontWeight: "600",
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    color:
                                      isdark === "light"
                                        ? iscolour?.Colour10
                                        : iscolourDark?.Colour10,
                                  }}
                                >
                                  {item.value}
                                </div>
                              </div>
                            </div>
                          </Col>
                        ))}
                      </Row>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          )}

          {renderPage()}
        </Col>
      </Row>
      {showDatePicker && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 99999,
          }}
          onClick={() => setShowDatePicker(false)}
        >
          <FASCalender
            isdark={isdark}
            iscolour={iscolour}
            iscolourDark={iscolourDark}
          />
          <div
            style={{
              background:
                isdark === "light" ? iscolour?.Colour3 : iscolourDark?.Colour3,

              borderRadius: "20px",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <Calendar
              className="custom-calendar"
              selectRange={true}
              onChange={(value) => {
                if (Array.isArray(value)) {
                  setDateRange([
                    {
                      startDate: value[0],
                      endDate: value[1],
                      key: "selection",
                    },
                  ]);
                }
              }}
              value={
                dateRange?.[0]?.startDate && dateRange?.[0]?.endDate
                  ? [dateRange[0].startDate, dateRange[0].endDate]
                  : null
              }
            />

            <div
              className="date-picker-footer"
              style={{
                textAlign: "center",
                marginTop: "15px",
                padding: "12px",
                background:
                  isdark === "light"
                    ? iscolour?.Colour3
                    : iscolourDark?.Colour3,
                borderRadius: "0 0 20px 20px",
              }}
            >
              <button
                onClick={() => setShowDatePicker(false)}
                style={{
                  padding: "10px",
                  borderRadius: "12px",
                  border: "none",
                  cursor: "pointer",
                  fontWeight: "700",
                  color: "#fff",
                  background:
                    isdark === "light"
                      ? iscolour?.Colour12
                      : iscolourDark?.Colour7,
                  boxShadow: "0 4px 10px rgba(0,0,0,0.25)",
                  transition: "0.2s ease",
                }}
                onMouseEnter={(e) => {
                  e.target.style.opacity = "0.85";
                  e.target.style.transform = "scale(1.05)";
                }}
                onMouseLeave={(e) => {
                  e.target.style.opacity = "1";
                  e.target.style.transform = "scale(1)";
                }}
              >
                Done
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
